"use strict";
exports.__esModule = true;
var css_helpers_1 = require("./../../core/css-helpers");
var __1 = require("./../../");
var animated_text_container_1 = require("../../core/animated-text-container");
function is_touch_device() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function (query) {
        return window.matchMedia(query).matches;
    };
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    }
    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}
var TelegramChartTooltipFeature = /** @class */ (function () {
    function TelegramChartTooltipFeature() {
        this.valueTooltipVisible = true;
        this.renderTarget = null;
        this.yLabelValues = {};
        this.onTouchStartBound = this.onTouchStart.bind(this);
        this.onPointerMoveBound = this.onPointerMove.bind(this);
        this.onPointerOutBound = this.onPointerOut.bind(this);
    }
    TelegramChartTooltipFeature.prototype.onDataChange = function () {
        this.createTooltip();
    };
    TelegramChartTooltipFeature.prototype.onResize = function () {
        this.tooltipCanvas.width = this.renderTarget.canvas.width;
        this.tooltipCanvas.height = this.renderTarget.canvas.height;
        this.createTooltip();
    };
    TelegramChartTooltipFeature.prototype.onAttach = function (renderTarget) {
        this.renderTarget = renderTarget;
        this.createTooltip();
        this.tooltipCanvas = renderTarget.chart.document.createElement('canvas');
        this.tooltipCanvas.width = renderTarget.canvas.width;
        this.tooltipCanvas.height = renderTarget.canvas.height;
        this.tooltipCanvas.className = 'tooltip-canvas';
        renderTarget.canvas.parentElement.appendChild(this.tooltipCanvas);
        this.tooltipCanvasContext = this.tooltipCanvas.getContext('2d');
        this.tooltipCanvas.addEventListener('touchmove', this.onPointerMoveBound);
        this.tooltipCanvas.addEventListener('touchstart', this.onTouchStartBound);
        if (!is_touch_device()) {
            this.tooltipCanvas.addEventListener('mousemove', this.onPointerMoveBound);
            this.tooltipCanvas.addEventListener('mouseout', this.onPointerOutBound);
            //this.tooltipCanvas.addEventListener('touchend', this.onPointerOutBound);
            this.tooltipCanvas.addEventListener('mousedown', this.zoomIn.bind(this));
        }
    };
    TelegramChartTooltipFeature.prototype.onTouchStart = function (event) {
        this.onPointerMove(event);
        //event.preventDefault();
        //return false;
    };
    TelegramChartTooltipFeature.prototype.onPointerMove = function (event) {
        if (event.touches && event.target != this.tooltipCanvas) {
            this.onPointerOut();
        }
        var offsetX = event instanceof MouseEvent ? event.offsetX : event.touches[0].clientX;
        var valueIndex = this.renderTarget.chart.findDataXIndexForCanvasPosition(__1.TelegramChart.pixelsToCanvasSize(offsetX), this.renderTarget, this.renderTarget.chart.currentZoomState);
        this.renderTarget.chart.selectXValueIndex(valueIndex);
        var value = this.renderTarget.chart.getCurrentZoomLevelXColumn()[valueIndex];
        console.log('Selected value', new Date(value));
    };
    TelegramChartTooltipFeature.prototype.onPointerOut = function () {
        this.renderTarget.chart.unSelectXValue();
        this.tooltipCanvasContext.clearRect(0, 0, this.tooltipCanvas.width, this.tooltipCanvas.height);
    };
    TelegramChartTooltipFeature.prototype.zoomIn = function (event) {
        var chart = this.renderTarget.chart;
        if (this.renderTarget.chart.selectedXValueIndex == null) {
            var offsetX = event instanceof MouseEvent ? event.offsetX : event.touches[0].clientX;
            this.renderTarget.chart.selectedXValueIndex = chart.findDataXIndexForCanvasPosition(__1.TelegramChart.pixelsToCanvasSize(offsetX), this.renderTarget, this.renderTarget.chart.currentZoomState);
        }
        var value = chart.getCurrentZoomLevelXColumn()[chart.selectedXValueIndex];
        chart.zoomIn(value);
        this.renderTarget.chart.selectedXValueIndex = null;
        this.renderTarget.viewportChanged = true;
        chart.requestRender();
    };
    TelegramChartTooltipFeature.prototype.getTooltipYLabelId = function (yIndex) {
        var data = this.renderTarget.chart.getCurrentZoomLevelData();
        return "telegram-chart-tooltip-label-" + data['columns'][yIndex][0];
    };
    TelegramChartTooltipFeature.prototype.createTooltip = function () {
        var parent = this.renderTarget.chart.containerElement;
        var doc = this.renderTarget.chart.document;
        if (this.tooltipContainer != null) {
            parent.removeChild(this.tooltipContainer);
            if (this.tooltipContainer.hasOwnProperty('remove')) {
                this.tooltipContainer.remove();
            }
            this.tooltipContainer = null;
        }
        this.tooltipContainer = doc.createElement('div');
        this.tooltipContainer.className = 'telegram-charts-tooltip';
        this.tooltipContainer.style.pointerEvents = 'none';
        this.tooltipContainer.onclick = this.zoomIn.bind(this);
        var xLabelContainer = doc.createElement('div');
        xLabelContainer.className = 'x-label-container';
        if (this.renderTarget.chart.currentZoomState && this.renderTarget.chart.currentZoomState.zoomLevelIndex < this.renderTarget.chart.zoomLevelsConfig.length - 1) {
            var arrow = doc.createElement('div');
            arrow.className = 'tooltip-arrow';
            arrow.innerHTML = "\n            <?xml version='1.0' encoding='utf-8'?>\n            <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 129 129\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" enable-background=\"new 0 0 129 129\">\n            <g>\n                <path d=\"m40.4,121.3c-0.8,0.8-1.8,1.2-2.9,1.2s-2.1-0.4-2.9-1.2c-1.6-1.6-1.6-4.2 0-5.8l51-51-51-51c-1.6-1.6-1.6-4.2 0-5.8 1.6-1.6 4.2-1.6 5.8,0l53.9,53.9c1.6,1.6 1.6,4.2 0,5.8l-53.9,53.9z\"/>\n            </g>\n            </svg>\n            ";
            this.tooltipContainer.appendChild(arrow);
        }
        this.xLabelDateContainer = new animated_text_container_1.AnimatedTextContainer(doc, 18);
        this.xLabelMonthContainer = new animated_text_container_1.AnimatedTextContainer(doc, 18);
        this.xLabelYearContainer = new animated_text_container_1.AnimatedTextContainer(doc, 18);
        xLabelContainer.appendChild(this.xLabelDateContainer.element);
        xLabelContainer.appendChild(this.xLabelMonthContainer.element);
        xLabelContainer.appendChild(this.xLabelYearContainer.element);
        this.tooltipContainer.appendChild(xLabelContainer);
        var inner = this.renderTarget.chart.document.createElement('div');
        inner.className = 'telegram-charts-tooltip-inner';
        this.tooltipContainer.appendChild(inner);
        var data = this.renderTarget.chart.getCurrentZoomLevelData();
        if (data) {
            for (var i = 1; i < data['columns'].length; i++) {
                var yId = data['columns'][i][0];
                var yLabel = doc.createElement('div');
                var yColor = this.renderTarget.chart.getLineColorByIndex(i, this.renderTarget.chart.currentZoomState);
                yLabel.className = 'telegram-chart-tooltip-label';
                yLabel.id = this.getTooltipYLabelId(i);
                var yLabelText = doc.createElement('h3');
                yLabelText.innerHTML = this.renderTarget.chart.getLineName(i, this.renderTarget.chart.currentZoomState);
                yLabel.appendChild(yLabelText);
                var yLabelValue = doc.createElement('div');
                yLabelValue.className = 'telegram-chart-tooltip-value';
                yLabelValue.style.color = yColor;
                var yLabelValueContainer = new animated_text_container_1.AnimatedTextContainer(doc, 18);
                this.yLabelValues[yId] = yLabelValueContainer;
                yLabelValue.appendChild(yLabelValueContainer.element);
                yLabel.appendChild(yLabelValue);
                inner.appendChild(yLabel);
            }
        }
        parent.appendChild(this.tooltipContainer);
        if (this.tooltipCanvasContext) {
            this.tooltipCanvasContext.clearRect(0, 0, this.tooltipCanvas.width, this.tooltipCanvas.height);
        }
    };
    TelegramChartTooltipFeature.prototype.onYMinMaxChange = function () { };
    TelegramChartTooltipFeature.prototype.renderBackground = function () {
        this.tooltipCanvasContext.clearRect(0, 0, this.tooltipCanvas.width, this.tooltipCanvas.height);
        if (this.renderTarget.chart.selectedXValueIndex != null) {
            this.renderVerticalRuler();
        }
    };
    TelegramChartTooltipFeature.prototype.renderVerticalRuler = function () {
        var chart = this.renderTarget.chart;
        var data = chart.data.get(chart.currentZoomState);
        var firstYId = data['columns'][1][0];
        var isBarChart = data['types'][firstYId] == __1.ChartColumnType.bar;
        if (!isBarChart) {
            this.tooltipContainer.style.opacity = '1';
            this.valueTooltipVisible = true;
            var xColumn = chart.getCurrentZoomLevelXColumn();
            var xValue = xColumn[this.renderTarget.chart.selectedXValueIndex];
            var linePosition = this.renderTarget.chart.xValueToCanvasPosition(xValue, this.renderTarget, chart.currentZoomState, this.renderTarget.viewPortPadding.left, this.renderTarget.viewPortPadding.right);
            this.tooltipCanvasContext.beginPath();
            this.tooltipCanvasContext.strokeStyle = chart.tooltipLineColor;
            this.tooltipCanvasContext.lineWidth = __1.TelegramChart.pixelsToCanvasSize(1);
            this.tooltipCanvasContext.moveTo(linePosition, this.renderTarget.viewPortPadding.top);
            this.tooltipCanvasContext.lineTo(linePosition, this.renderTarget.canvas.height - this.renderTarget.viewPortPadding.bottom);
            this.tooltipCanvasContext.stroke();
        }
    };
    TelegramChartTooltipFeature.prototype.renderForeground = function () {
        var chart = this.renderTarget.chart;
        var data = chart.getCurrentZoomLevelData();
        if (this.renderTarget.chart.selectedXValueIndex != null) {
            this.tooltipContainer.style.pointerEvents = 'all';
            this.tooltipContainer.style.opacity = '1';
            this.valueTooltipVisible = true;
            var xColumn = chart.getCurrentZoomLevelXColumn();
            var xValue = xColumn[this.renderTarget.chart.selectedXValueIndex];
            var d = new Date(xValue);
            if (this.renderTarget.chart.currentZoomState.config.xStep == __1.TelegramChart.oneDayMilliseconds) {
                var dayName = __1.TelegramChart.dayNames[d.getDay()];
                var newDateLabelText = dayName + ", " + d.getDate();
                if (this.xLabelDateContainer.tag != newDateLabelText) {
                    var newDateLabelElem = this.renderTarget.chart.document.createElement('span');
                    newDateLabelElem.innerText = newDateLabelText;
                    this.xLabelDateContainer.appendFromBottom(newDateLabelElem);
                    this.xLabelDateContainer.tag = newDateLabelText;
                }
                var monthName = __1.TelegramChart.monthNames[d.getMonth()];
                if (this.xLabelMonthContainer.tag != monthName) {
                    var newMonthLabel = this.renderTarget.chart.document.createElement('span');
                    newMonthLabel.innerText = monthName;
                    this.xLabelMonthContainer.appendFromBottom(newMonthLabel);
                    this.xLabelMonthContainer.tag = monthName;
                }
                var yearName = d.getFullYear().toString();
                if (this.xLabelYearContainer.tag != yearName) {
                    var newYearLabel = this.renderTarget.chart.document.createElement('span');
                    newYearLabel.innerText = yearName;
                    this.xLabelYearContainer.appendFromBottom(newYearLabel);
                    this.xLabelYearContainer.tag = yearName;
                }
            }
            else if (this.renderTarget.chart.currentZoomState.config.xStep == __1.TelegramChart.oneHourMilliseconds) {
                var minutes = d.getUTCMinutes().toString();
                if (minutes.length == 1) {
                    minutes = '0' + minutes;
                }
                var newDateLabelText = d.getUTCHours() + ":" + minutes;
                if (this.xLabelDateContainer.tag != newDateLabelText) {
                    var newDateLabelElem = this.renderTarget.chart.document.createElement('span');
                    newDateLabelElem.innerText = newDateLabelText;
                    this.xLabelDateContainer.appendFromBottom(newDateLabelElem);
                    this.xLabelDateContainer.tag = newDateLabelText;
                }
                var newMonthLabel = this.renderTarget.chart.document.createElement('span');
                this.xLabelMonthContainer.appendFromBottom(newMonthLabel);
                this.xLabelMonthContainer.tag = null;
                var newYearLabel = this.renderTarget.chart.document.createElement('span');
                this.xLabelYearContainer.appendFromTop(newYearLabel);
                this.xLabelYearContainer.tag = null;
            }
            var containerWidth = this.renderTarget.chart.containerElement.getBoundingClientRect().width;
            var tooltipPosition = chart.xValueToCanvasPosition(xValue, this.renderTarget, this.renderTarget.chart.currentZoomState, this.renderTarget.viewPortPadding.left, this.renderTarget.viewPortPadding.right, containerWidth);
            if (tooltipPosition > containerWidth / 2) {
                tooltipPosition -= (this.tooltipContainer.getBoundingClientRect().width + 100);
            }
            this.tooltipContainer.style.transform = css_helpers_1.CssHelpers.getTranslateX(tooltipPosition);
            for (var y = 1; y < data["columns"].length; y++) {
                var yVisible = true;
                if (this.renderTarget.yVisibility[data['columns'][y][0]] === false) {
                    yVisible = false;
                }
                var tooltipLabel = this.tooltipContainer.querySelector('#' + this.getTooltipYLabelId(y));
                if (tooltipLabel != null && yVisible) {
                    var yId = data['columns'][y][0];
                    var yValue = data['columns'][y][this.renderTarget.chart.selectedXValueIndex];
                    if (yValue == null) {
                        continue;
                    }
                    var yValueString = yValue.toString();
                    if (this.yLabelValues[yId].tag != yValueString) {
                        var newValueElem = this.renderTarget.chart.document.createElement('span');
                        newValueElem.innerText = yValueString;
                        this.yLabelValues[yId].tag = yValueString;
                        this.yLabelValues[yId].appendFromBottom(newValueElem);
                    }
                    tooltipLabel.style.display = 'flex';
                    tooltipLabel.className = tooltipLabel.className.replace('hidden', '');
                    this.renderSelectedValues();
                }
                else {
                    tooltipLabel.className = tooltipLabel.className.replace('hidden', '') + ' hidden';
                }
            }
            this.renderTarget.chart.loadData(this.renderTarget.chart.currentZoomState, this.renderTarget.chart.getZoomInState(xValue), function () { });
        }
        else if (this.valueTooltipVisible) {
            this.valueTooltipVisible = false;
            this.tooltipContainer.style.opacity = '0';
            this.tooltipContainer.style.pointerEvents = 'none';
        }
    };
    TelegramChartTooltipFeature.prototype.renderSelectedValues = function () {
        var chart = this.renderTarget.chart;
        var data = chart.getCurrentZoomLevelData();
        var xStepWidth = chart.xValueToCanvasPosition(this.renderTarget.viewPortDataFrame.get(chart.currentZoomState).x.min + chart.currentZoomState.config.xStep, this.renderTarget, chart.currentZoomState, 0, //t.viewPortPadding.left,
        0 //t.viewPortPadding.right,
        );
        var xStepWidthHalf = Math.round(xStepWidth / 2);
        if (xStepWidthHalf < 1) {
            xStepWidthHalf = 1;
        }
        var xColumn = chart.getCurrentZoomLevelXColumn();
        for (var y = data['columns'].length - 1; y >= 1; y--) {
            var yVisible = true;
            if (this.renderTarget.yVisibility[data['columns'][y][0]] === false) {
                yVisible = false;
            }
            if (yVisible) {
                var yId = data['columns'][y][0];
                var yValue = data['columns'][y][this.renderTarget.chart.selectedXValueIndex];
                if (yValue == null) {
                    continue;
                }
                var yColor = this.renderTarget.chart.getLineColorByIndex(y, chart.currentZoomState);
                var xValueInCanvasCoords = chart.xValueToCanvasPosition(xColumn[chart.selectedXValueIndex], this.renderTarget, chart.currentZoomState, this.renderTarget.viewPortPadding.left, this.renderTarget.viewPortPadding.right);
                this.tooltipCanvasContext.fillStyle = yColor;
                if (data['types'][yId] == __1.ChartColumnType.bar) {
                    var sumOfPreviouslyRenderedYValues = 0;
                    for (var previousYIndex = 1; previousYIndex < y; previousYIndex++) {
                        var previousYId = data['columns'][previousYIndex][0];
                        var previousYValue = data['columns'][previousYIndex][chart.selectedXValueIndex];
                        previousYValue = previousYValue * this.renderTarget.yOpacity[previousYId];
                        sumOfPreviouslyRenderedYValues += previousYValue;
                    }
                    yValue *= this.renderTarget.yOpacity[yId];
                    yValue += sumOfPreviouslyRenderedYValues;
                    var yValueInCanvasCoords = chart.yValueToCanvasPosition(yValue, this.renderTarget, chart.currentZoomState, this.renderTarget.viewPortPadding.top, this.renderTarget.viewPortPadding.bottom, this.renderTarget.viewPortScalePerY ? yId : null);
                    this.tooltipCanvasContext.fillRect(xValueInCanvasCoords - xStepWidthHalf, yValueInCanvasCoords, xStepWidth, this.renderTarget.canvasHeight - yValueInCanvasCoords - this.renderTarget.viewPortPadding.bottom);
                }
                else if (data['types'][yId] == __1.ChartColumnType.line || data['types'][yId] == __1.ChartColumnType.area) {
                    var yValueInCanvasCoords = chart.yValueToCanvasPosition(yValue, this.renderTarget, chart.currentZoomState, this.renderTarget.viewPortPadding.top, this.renderTarget.viewPortPadding.bottom, this.renderTarget.viewPortScalePerY ? yId : null);
                    this.tooltipCanvasContext.beginPath();
                    this.tooltipCanvasContext.arc(xValueInCanvasCoords, yValueInCanvasCoords, __1.TelegramChart.pixelsToCanvasSize(2), 0, 2 * Math.PI, false);
                    this.tooltipCanvasContext.lineWidth = __1.TelegramChart.pixelsToCanvasSize(4);
                    this.tooltipCanvasContext.strokeStyle = chart.backgroundColor;
                    this.tooltipCanvasContext.stroke();
                    this.tooltipCanvasContext.beginPath();
                    this.tooltipCanvasContext.arc(xValueInCanvasCoords, yValueInCanvasCoords, __1.TelegramChart.pixelsToCanvasSize(3.5), 0, 2 * Math.PI, false);
                    this.tooltipCanvasContext.lineWidth = this.renderTarget.lineWidth;
                    this.tooltipCanvasContext.strokeStyle = yColor;
                    this.tooltipCanvasContext.stroke();
                }
            }
        }
    };
    return TelegramChartTooltipFeature;
}());
exports.TelegramChartTooltipFeature = TelegramChartTooltipFeature;
//# sourceMappingURL=tooltip.js.map